import { render, staticRenderFns } from "./accvoucher.vue?vue&type=template&id=36b98c4a&scoped=true&"
import script from "./accvoucher.vue?vue&type=script&lang=js&"
export * from "./accvoucher.vue?vue&type=script&lang=js&"
import style0 from "./accvoucher.vue?vue&type=style&index=0&id=36b98c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b98c4a",
  null
  
)

export default component.exports